import { render } from "./blocks.vue?vue&type=template&id=19f22c08&scoped=true"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"

import "./blocks.vue?vue&type=style&index=0&id=19f22c08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f22c08"]])

export default __exports__